import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IdbStorage } from "@/store/idbStorage.ts";

export interface CashInputState {
  cashInputTotal: number;
  setCashInputTotal: (cashInputTotal: number) => void;
  resetStore: () => void;
}

export const useCashInputStore = create<CashInputState>()(
  devtools(
    persist(
      (set) => ({
        cashInputTotal: 0,
        setCashInputTotal: (cashInputTotal: number) => set({ cashInputTotal }),
        resetStore: () => set({ cashInputTotal: 0 }),
      }),
      {
        name: "cash-input-store",
        partialize: (state) => ({
          cashInputTotal: state.cashInputTotal,
        }),
        storage: createJSONStorage(() => IdbStorage),
      }
    )
  )
);
